
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuePattern from 'vue-pattern-input';
import Affix from 'vue-affix';
import VueTheMask from 'vue-the-mask';
import store from './store/index';
import Inview from 'vueinview';
import VueProgressBar from 'vue-progressbar';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VTooltip from 'v-tooltip'
import VueGtm from 'vue-gtm';
import vClickOutside from 'v-click-outside';
import VModal from 'vue-js-modal'

import 'vue-js-modal/dist/styles.css'
Vue.use(VModal)
   
Vue.use(vClickOutside);
Vue.use(VueGtm, {
  id: 'GTM-NWCS3BD', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [] // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
  loaderOptions: {
    useRecaptchaNet: true
  }
})
Vue.use(VTooltip)
Vue.use(Inview);

import Axios from 'axios';

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true
});

Vue.prototype.$http = axios;
Vue.prototype.Axios = axios;
Vue.use(VueTheMask);

Vue.use(Affix);

Vue.use(vuePattern);

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

require('jquery-validation');

require('select2');



Vue.use(VueProgressBar, {
  color: '#000',
  failedColor: 'red',
  thickness: '5px',
  position: 'absolute',
  location: 'bottom'
});


// Custom directive to make work select2 with 2 ways data binding from vue
Vue.directive('select2', {
  inserted(el) {
    $(el).on('select2:select', () => {
      const event = new Event('change', { bubbles: true, cancelable: true });
      el.dispatchEvent(event);
    });

    $(el).on('select2:unselect', () => {
      const event = new Event('change', { bubbles: true, cancelable: true })
      el.dispatchEvent(event)
    })
  },
});

Vue.filter('moneyFormatter', function (value, locale, currency, symbol) {
  if (!locale) {
    value = Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 }).format(value).replace('$', '$ ');
  } else {
    value = Intl.NumberFormat(locale, { style: "currency", currency: currency, minimumFractionDigits: 0 }).format(value).replace(symbol, symbol + ' ');
  }
  return value;
});


// V-PRINT CUSTOM DIRECTIVE ///////////////////////////////////
//const print = {};

function printSection(el, binding) {
  // insertar css especial para la impresión, esto mostrar un contenedor especial y ocultara el resto de contenido
  let style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode("@media screen{#printSection{display:none}}@media print{#printSection,body{overflow:visible!important}body *{visibility:hidden}#printSection,#printSection *{visibility:visible}#printSection{position:absolute;left:0;top:0;right:0}#printSection table{width:100%!important}}"));
  document.body.appendChild(style);

  // busco si existe mi sección para imprimir
  let printSection = document.getElementById('printSection');

  // si no existe la creo y la inserto en el body
  if (!printSection) {
    printSection = document.createElement('div');
    printSection.id = 'printSection';
    document.body.appendChild(printSection);
  }

  // creo el evento del click para cada que se de click en imprimir
  el.addEventListener('click', () => {

    // busco el contenido a imprimir, esto ya que como parametro tenia el id
    var elemToPrint = document.getElementById(binding.value);

    //si existe el contenido entonces lo imprimiré
    if (elemToPrint) {
      printSection.innerHTML = ''; // limpio el contenido anterior de mi sección a imprimir
      printElement(elemToPrint);
    }
  });

  // funcion para imprimir
  function printElement(elem) {

    // creo un nodo y lo inserto dentro de mi sección a imprimir
    let domClone = elem.cloneNode(true);
    printSection.appendChild(domClone);
    window.print(); //mando a imprimir
  }
}


// registro la directiva
Vue.directive('print', {
  bind(el, binding) {
    printSection(el, binding)
  }
})

// END CODE: V-PRINT CUSTOM DIRECTIVE ///////////////////////////////////


Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
